import React, { useState, useEffect, useRef, ChangeEvent } from 'react'

import {
  Card,
  CheckBox,
  Col,
  Grid,
  Input,
  Picker,
  RadioGroup,
  Row,
  Text,
  Button,
  SimpleCard,
  Span,
  UnidadeGestoraFields
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { ReportsRow, getItemSize, buildSetSize } from 'components/ReportsRow'
import { useLoading, useModal, useToggle, useWindowResize } from 'hooks'
import moment, { Moment } from 'moment'
import { useHistory } from 'react-router-dom'
import { VariableSizeList as List } from 'react-window'
import { IReportsEffectiveModel } from 'services/database/reportsDatabase'
import { reportsDatabase } from 'services/database/reportsDatabase'
import {
  ReportsEffectivesNGTServices,
  IFillCardsResponse
} from 'services/NGT/ReportsEffectives'
import { COLORS, SPACING } from 'utils'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import { isValid, isBefore } from 'date-fns'

export interface typeArray {
  id: number
  name: string
  checked: boolean
}

export interface IRequestBody {
  competenciaDataFim: string | Date
  competenciaDataIni: string | Date
  flTodos: boolean
  flValidacaoAnalista: boolean
  flValidacaoContraparte: boolean
  subcontratadasIds: number[]
  empresasIds: number[]
  fornecedoresIds: number[]
  contratosIds: number[]
  centrosIds: number[]
  flStatusMovimentacao: boolean
}

const ReportsEffectives: React.FC = () => {
  const check = localStorage.getItem("fLTodos");
  if (check == null) localStorage.setItem("fLTodos", true + "");
  type TiposGrid =
    | 'contrato'
    | 'fornecedor'
    | 'empresa'
    | 'centro'
    | 'subcontratadas'

  const { setLoading, setMsgErro } = useLoading()
  const { listen: historyListen, push } = useHistory()
  const [load, setLoad] = useState(false)

  const [relatorio, setRelatorio] = useState<string>('TTL')
  const [tipo, setTipo] = useState<string>('Contrato')

  const [checkAllSub, setCheckAllSub] = useState(false)
  const [checkAllFornecedor, setCheckAllFornecedor] = useState(false)
  const [checkAllEmpresa, setCheckAllEmpresa] = useState(false)
  const [limpar, setLimpar] = useState<boolean>(false)
  const [checkAllCentro, setCheckAllCentro] = useState(false)
  const [checkAllSubFornecedor, setCheckAllSubFornecedor] = useState(false)

  const [contrato, setContrato] = useState<string>('')
  const [fornecedor, setFornecedor] = useState<string>('')
  const [empresa, setEmpresa] = useState<string>('')
  const [centro, setCentro] = useState<string>('')
  const [subcontratada, setSubcontratada] = useState<string>('')

  const [contratoList, setContratoList] = useState<typeArray[]>([])
  const [fornecedorList, setFornecedorList] = useState<typeArray[]>([])
  const [empresaList, setEmpresaList] = useState<typeArray[]>([])
  const [centroList, setCentroList] = useState<typeArray[]>([])
  const [subFornecedoresList, setSubFornecedoresList] = useState<typeArray[]>(
    []
  )

  const [contratosIds, setContratosIds] = useState<number[]>([])
  const [fornecedoresIds, setFornecedoresIds] = useState<number[]>([])
  const [empresasIds, setEmpresasIds] = useState<number[]>([])
  const [centrosIds, setCentrosIds] = useState<number[]>([])
  const [subcontratadasIds, setSubcontratadasIds] = useState<number[]>([])

  const [ignoreGridName, setIgnoreGridName] = useState<
    'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas' | null
  >(null)
  const [refresh, setRefresh] = useState<boolean>(false)

  const [periodoValidadeIni, setPeriodoValidadeIni] = useState<Date | Moment>(
    null
  )
  const [periodoValidadeFim, setPeriodoValidadeFim] = useState<Date | Moment>(
    null
  )

  const [firstMount, toggleFirstMount] = useToggle(true)

  const [unidadeGestoraID, setUnidadeGestoraID] =
    useState<IOnChangeUnidadeGestora>({} as IOnChangeUnidadeGestora)

  const [filterTodos, setFilterTodos] = useState(true)
  const [filterVContraparte, setFilterVContraparte] = useState(false)
  const [filterVAnalista, setFilterVAnalista] = useState(false)
  const [filterStatusMovimentacao, setFilterStatusMovimentacao] = useState(false);

  const { showModal } = useModal()

  const historyListenerRef = useRef<() => void | null>(null)
  const REPORTS_PATHS = [
    '/ngt/relatorios-vizualizar-efetivos-hht-salario',
    '/ngt/relatorios-fornecedor',
    '/ngt/relatorios-vizualizar-efetivos-terceiros-fornecedor',
    '/ngt/relatorios-efetivos'
  ]

  const handleCheckAll = (
    event: ChangeEvent<HTMLInputElement>,
    tipoGrid: TiposGrid
  ) => {
    return event.target.checked
      ? ActionCheckbox('checkAll', tipoGrid)
      : !isFirstMount.current
        ? ActionCheckbox('unCheckAll', tipoGrid)
        : null
  }

  const isFirstMount = useRef<boolean>(true)

  useEffect(() => {
    setLoading('loading')
    reportsDatabase.effectives
      .where({ id: 1 })
      .first()
      .then((effectivesResult) => {
        if (effectivesResult) {
          setRelatorio(effectivesResult.relatorio)
          setContrato(effectivesResult.contrato)
          setTipo(effectivesResult.tipo)
          setFornecedor(effectivesResult.fornecedor)
          setEmpresa(effectivesResult.empresa)
          setCentro(effectivesResult.centro)
          setSubcontratada(effectivesResult.subcontratada)
          setFilterTodos(effectivesResult.flags.todos)
          setFilterVContraparte(effectivesResult.flags.validContraparte)
          setFilterVAnalista(effectivesResult.flags.validAnalista)
          setPeriodoValidadeIni(
            moment(effectivesResult?.competenciaInicio).isValid()
              ? moment(effectivesResult?.competenciaInicio)
              : null
          )
          setPeriodoValidadeFim(
            moment(effectivesResult?.competenciaFim).isValid()
              ? moment(effectivesResult?.competenciaFim)
              : null
          )

          setContratoList(
            effectivesResult.contratos.map((contrato) => ({
              checked: contrato.checked || false,
              id: contrato.key,
              name: contrato.value
            }))
          )
          setFornecedorList(
            effectivesResult.fornecedores.map((fornecedor) => ({
              checked: fornecedor.checked || false,
              id: fornecedor.key,
              name: fornecedor.value
            }))
          )
          setEmpresaList(
            effectivesResult.empresas.map((empresa) => ({
              checked: empresa.checked || false,
              id: empresa.key,
              name: empresa.value
            }))
          )
          setCentroList(
            effectivesResult.centros.map((centro) => ({
              checked: centro.checked || false,
              id: centro.key,
              name: centro.value
            }))
          )
          setSubFornecedoresList(
            effectivesResult.subContratadas.map((subfornecedor) => ({
              checked: subfornecedor.checked || false,
              id: subfornecedor.key,
              name: subfornecedor.value
            }))
          )

          setContratosIds(
            effectivesResult.contratos
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setFornecedoresIds(
            effectivesResult.fornecedores
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setEmpresasIds(
            effectivesResult.empresas
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setCentrosIds(
            effectivesResult.centros
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setSubcontratadasIds(
            effectivesResult.subContratadas
              .filter((value) => value.checked)
              .map((value) => value.key)
          )

          setRelatorio(effectivesResult.isTipoTerceiros ? 'TTL' : 'HHT')
          setTipo(effectivesResult.isTipoContrato ? 'Contrato' : 'Fornecedor')

          // setUnidadeGestoraID(effectivesResult.unidadeGestoraId)
        }
      })
      .finally(() => ((isFirstMount.current = false), setLoading('idle')))
  }, [])

  useEffect(() => {
    historyListenerRef.current = historyListen((location) => {
      if (!REPORTS_PATHS.includes(location.pathname)) {
        reportsDatabase.effectives.delete(1)
        historyListenerRef?.current()
      }
    })
  }, [])

  useEffect(() => {
    if (!isFirstMount.current) {
      !isFirstMount.current && !limpar && getFillCards()
      firstMount && limpar && toggleFirstMount()
    }
  }, [
    refresh,
    periodoValidadeIni,
    periodoValidadeFim,
    unidadeGestoraID,
    filterTodos,
    filterVAnalista,
    filterVContraparte
  ])

  useEffect(() => {
    if (!isFirstMount.current) {
      handleClear()
    }
  }, [relatorio])

  const refreshGrid = (): void => {
    setRefresh((prevState) => !prevState)
  }

  const ActionCheckbox = (
    actionType: 'add' | 'remove' | 'checkAll' | 'unCheckAll',
    grid: TiposGrid,
    id?: number
  ) =>
  ({
    add: {
      centro: () => setCentrosIds((prevState) => [...prevState, id]),
      contrato: () => setContratosIds((prevState) => [...prevState, id]),
      empresa: () => setEmpresasIds((prevState) => [...prevState, id]),
      fornecedor: () => setFornecedoresIds((prevState) => [...prevState, id]),
      subcontratadas: () =>
        setSubcontratadasIds((prevState) => [...prevState, id])
    },
    checkAll: {
      centro: () => {
        setCentroList((prevState) =>
          prevState.map((centro) => ({ ...centro, checked: true }))
        )
        setCheckAllCentro(true)
        setCentrosIds(centroList.map((centro) => centro.id))
        setIgnoreGridName('centro')
        refreshGrid()
      },
      contrato: () => {
        setContratoList((prevState) =>
          prevState.map((contrato) => ({ ...contrato, checked: true }))
        )
        setCheckAllSub(true)
        setContratosIds(contratoList.map((contrato) => contrato.id))
        setIgnoreGridName('contrato')
        refreshGrid()
      },
      empresa: () => {
        setEmpresaList((prevState) =>
          prevState.map((empresa) => ({ ...empresa, checked: true }))
        )
        setCheckAllEmpresa(true)
        setEmpresasIds(empresaList.map((empresa) => empresa.id))
        setIgnoreGridName('empresa')
        refreshGrid()
      },
      fornecedor: () => {
        setFornecedorList((prevState) =>
          prevState.map((fornecedor) => ({ ...fornecedor, checked: true }))
        )
        setCheckAllFornecedor(true)
        setFornecedoresIds(fornecedorList.map((fornecedor) => fornecedor.id))
        setIgnoreGridName('fornecedor')
        refreshGrid()
      },
      subcontratadas: () => {
        setSubFornecedoresList((prevState) =>
          prevState.map((subfornecedor) => ({
            ...subfornecedor,
            checked: true
          }))
        )
        setSubcontratadasIds(
          subFornecedoresList.map((subfornecedor) => subfornecedor.id)
        )
        setCheckAllSubFornecedor(true)
        setIgnoreGridName('subcontratadas')
        refreshGrid()
      }
    },
    remove: {
      centro: () =>
        setCentrosIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        ),
      contrato: () =>
        setContratosIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        ),
      empresa: () =>
        setEmpresasIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        ),
      fornecedor: () =>
        setFornecedoresIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        ),
      subcontratadas: () =>
        setSubcontratadasIds((prevState) =>
          prevState.filter((itemID) => itemID !== id)
        )
    },
    unCheckAll: {
      centro: () => {
        setCentroList((prevState) =>
          prevState.map((centro) => ({ ...centro, checked: false }))
        )
        setCentrosIds([])
        setIgnoreGridName(null)
        refreshGrid()
        setCheckAllCentro(false)
      },
      contrato: () => {
        setContratoList((prevState) =>
          prevState.map((contrato) => ({ ...contrato, checked: false }))
        )
        setContratosIds([])
        setIgnoreGridName(null)
        refreshGrid()
        setCheckAllSub(false)
      },
      empresa: () => {
        setEmpresaList((prevState) =>
          prevState.map((empresa) => ({ ...empresa, checked: false }))
        )
        setEmpresasIds([])
        setIgnoreGridName(null)
        refreshGrid()
        setCheckAllEmpresa(false)
      },
      fornecedor: () => {
        setFornecedorList((prevState) =>
          prevState.map((fornecedor) => ({ ...fornecedor, checked: false }))
        )
        setFornecedoresIds([])
        setIgnoreGridName(null)
        refreshGrid()
        setCheckAllFornecedor(false)
      },
      subcontratadas: () => {
        setSubFornecedoresList((prevState) =>
          prevState.map((subfornecedor) => ({
            ...subfornecedor,
            checked: false
          }))
        )
        setCheckAllSubFornecedor(false)
        setSubcontratadasIds([])
        setIgnoreGridName(null)
        refreshGrid()
      }
    }
  }[actionType][grid]())

  const handleChangeItem = (
    checked: boolean,
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas',
    id: number
  ): void => {
    const actionType = checked ? 'add' : 'remove'
    let notUpdateLastGridInteraction = false

    if (
      grid === 'contrato' &&
      contratosIds.length === 1 &&
      contratosIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'fornecedor' &&
      fornecedoresIds.length === 1 &&
      fornecedoresIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'empresa' &&
      empresasIds.length === 1 &&
      empresasIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'centro' &&
      centrosIds.length === 1 &&
      centrosIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'subcontratadas' &&
      contratosIds.length === 1 &&
      subcontratadasIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true

    if (notUpdateLastGridInteraction) {
      setIgnoreGridName(null)
    } else {
      setIgnoreGridName(grid)
    }

    ActionCheckbox(actionType, grid, id)
    refreshGrid()
  }

  const fillCardsExcept = (
    cardsData: IFillCardsResponse,
    doNotFillCard: string
  ): void => {
    clearIdsLists(cardsData)

    if (doNotFillCard !== 'contrato') setContratoList(cardsData.contratos)
    if (doNotFillCard !== 'fornecedor')
      setFornecedorList(cardsData.fornecedores)
    if (doNotFillCard !== 'empresa') setEmpresaList(cardsData.empresas)
    if (doNotFillCard !== 'centro') setCentroList(cardsData.centros)
    if (doNotFillCard !== 'subcontratadas')
      setSubFornecedoresList(cardsData.subFornecedores)

    if (doNotFillCard === 'contrato') {
      const checkedIds = cardsData.contratos.map(
        (contrato) => contrato.checked && contrato.id
      )

      setContratoList((prevState) =>
        prevState.map((contrato) => ({
          ...contrato,
          checked: checkedIds.includes(contrato.id)
        }))
      )
    }
    if (doNotFillCard === 'fornecedor') {
      const checkedIds = cardsData.fornecedores.map(
        (fornecedor) => fornecedor.checked && fornecedor.id
      )

      setFornecedorList((prevState) =>
        prevState.map((fornecedor) => ({
          ...fornecedor,
          checked: checkedIds.includes(fornecedor.id)
        }))
      )
    }
    if (doNotFillCard === 'empresa') {
      const checkedIds = cardsData.empresas.map(
        (empresa) => empresa.checked && empresa.id
      )

      setEmpresaList((prevState) =>
        prevState.map((empresa) => ({
          ...empresa,
          checked: checkedIds.includes(empresa.id)
        }))
      )
    }
    if (doNotFillCard === 'centro') {
      const checkedIds = cardsData.centros.map(
        (centro) => centro.checked && centro.id
      )

      setCentroList((prevState) =>
        prevState.map((centro) => ({
          ...centro,
          checked: checkedIds.includes(centro.id)
        }))
      )
    }
    if (doNotFillCard === 'subcontratadas') {
      const checkedIds = cardsData.subFornecedores.map(
        (subfornecedor) => subfornecedor.checked && subfornecedor.id
      )

      setSubFornecedoresList((prevState) =>
        prevState.map((subfornecedor) => ({
          ...subfornecedor,
          checked: checkedIds.includes(subfornecedor.id)
        }))
      )
    }
  }

  const removeOldIds = (
    newIdsList: number[],
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subcontratadas'
  ): void => {
    if (grid === 'contrato')
      setContratosIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'fornecedor')
      setFornecedoresIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'empresa')
      setEmpresasIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'centro')
      setCentrosIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'subcontratadas')
      setSubcontratadasIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
  }

  const clearIdsLists = (cardsData: IFillCardsResponse): void => {
    const contratosNewIds = cardsData.contratos.map((item) => item.id)
    const fornecedoresNewIds = cardsData.fornecedores.map((item) => item.id)
    const empresasNewIds = cardsData.empresas.map((item) => item.id)
    const centrosNewIds = cardsData.centros.map((item) => item.id)
    const subFornecedoresNewIds = cardsData.subFornecedores.map(
      (item) => item.id
    )

    removeOldIds(contratosNewIds, 'contrato')
    removeOldIds(fornecedoresNewIds, 'fornecedor')
    removeOldIds(empresasNewIds, 'empresa')
    removeOldIds(centrosNewIds, 'centro')
    removeOldIds(subFornecedoresNewIds, 'subcontratadas')
  }

  const fillCards = (cardsData: IFillCardsResponse): void => {
    clearIdsLists(cardsData)

    setContratoList(cardsData.contratos)
    setFornecedorList(cardsData.fornecedores)
    setEmpresaList(cardsData.empresas)
    setCentroList(cardsData.centros)
    setSubFornecedoresList(cardsData.subFornecedores)
  }

  const validaDataFim = () => {
    return moment(periodoValidadeFim).isValid()
      ? moment(periodoValidadeFim)
        .set({ hour: 0, millisecond: 0, minute: 0, second: 0 })
        .toISOString()
      :
      // relatorio === 'HHT' ? moment().toISOString() :
      null
  }

  const getFillCards = (isClickIcon?: boolean): void => {
    setLoading('loading')
    setLoad(true)

    ReportsEffectivesNGTServices()
      .FillCardsGeneric({
        ...(centrosIds.length > 0 && { centrosIds }),
        ...(contratosIds.length > 0 && { contratosIds }),
        ...(fornecedoresIds.length > 0 && { fornecedoresIds }),
        ...(empresasIds.length > 0 && { empresasIds }),
        ...(subcontratadasIds.length > 0 && { subcontratadasIds }),
        ...(periodoValidadeIni && {
          competenciaDataIni: moment(periodoValidadeIni)
            .set({ hour: 0, millisecond: 0, minute: 0, second: 0 })
            .toISOString()
        }),
        cdContrato: contrato,
        competenciaDataFim: validaDataFim(),
        flTodos: filterTodos || false,
        flValidacaoAnalista: filterVAnalista || false,
        flValidacaoContraparte: filterVContraparte || false,
        flStatusMovimentacao: filterStatusMovimentacao || false,
        isHht: relatorio === 'HHT',
        nmCentro: centro,
        nmEmpresa: empresa,
        nmFornecedor: fornecedor,
        nmSubcontratada: subcontratada,
        unidadeGestoraId: unidadeGestoraID
      })
      .then((response) => {
        if (response.status === 200) {
          const {
            data: { entity: cardsData }
          } = response

          if (isClickIcon) {
            fillCards(cardsData)
          } else if (ignoreGridName) {
            fillCardsExcept(cardsData, ignoreGridName)
          } else {
            fillCards(cardsData)
          }
        }

        setLoading('idle')
        setLoad(false)
        setLimpar(false)
      })
      .catch((err) => {
        setLoading('idle')
        setLoad(false)
        // setMsgErro('Erro')
        // toggleErrorModal()
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleClear = (): void => {
    setLoading('loading')
    setLimpar(true)
    reportsDatabase.effectives.delete(1).then(() => {
      setIgnoreGridName(null)

      setContrato('')
      setFornecedor('')
      setEmpresa('')
      setCentro('')

      setContratoList([])
      setFornecedorList([])
      setCentroList([])
      setEmpresaList([])
      setSubFornecedoresList([])

      setContratosIds([])
      setFornecedoresIds([])
      setEmpresasIds([])
      setCentrosIds([])
      setSubcontratadasIds([])

      // setUnidadeGestoraID({} as IOnChangeUnidadeGestora)

      setPeriodoValidadeIni(null)
      setPeriodoValidadeFim(null)

      setCheckAllCentro(false)
      setCheckAllSub(false)
      setCheckAllSubFornecedor(false)
      setCheckAllFornecedor(false)
      setCheckAllEmpresa(false)

      setFilterTodos(true)
      setFilterVAnalista(false)
      setFilterVContraparte(false)

      unidadeGestoraRef?.current?.clearForm()
    })
    setTimeout(() => {
      setLimpar(false)
      setLoading('idle')
    }, 300)
  }

  const setPersistInStorage = () => {
    const newChangesResult: IReportsEffectiveModel = {
      contrato: contrato,
      centro: centro,
      empresa: empresa,
      fornecedor: fornecedor,
      relatorio: relatorio,
      subcontratada: subcontratada,
      tipo: tipo,
      centros: centroList.map((centro) => ({
        checked: centrosIds.includes(centro.id),
        key: centro.id,
        value: centro.name
      })),
      competenciaFim: moment(periodoValidadeFim)?.toDate(),
      competenciaInicio: moment(periodoValidadeIni).toDate(),
      contratos: contratoList.map((contrato) => ({
        checked: contratosIds.includes(contrato.id),
        key: contrato.id,
        value: contrato.name
      })),
      empresas: empresaList.map((empresa) => ({
        checked: empresasIds.includes(empresa.id),
        key: empresa.id,
        value: empresa.name
      })),
      flags: {

        todos: filterTodos,
        validAnalista: filterVAnalista,
        validContraparte: filterVContraparte
      },
      fornecedores: fornecedorList.map((fornecedor) => ({
        checked: fornecedoresIds.includes(fornecedor.id),
        key: fornecedor.id,
        value: fornecedor.name
      })),
      id: 1,
      isTipoContrato: tipo === 'Contrato',
      isTipoTerceiros: relatorio === 'TTL',
      subContratadas: subFornecedoresList.map((subcontratada) => ({
        checked: subcontratadasIds.includes(subcontratada.id),
        key: subcontratada.id,
        value: subcontratada.name
      })),
      unidadeGestoraId: unidadeGestoraID
    }

    reportsDatabase.effectives
      .where({ id: 1 })
      .first()
      .then((effectivesExists) => {
        if (effectivesExists) {
          reportsDatabase.effectives.update(1, newChangesResult)
        } else {
          reportsDatabase.effectives.add(newChangesResult)
        }
      })
  }

  const setRequestBodyValues = (request_body: IRequestBody) => {
    if (contrato) {
      request_body['cdContrato'] = contrato
    }

    if (empresa) {
      request_body['nmEmpresa'] = empresa
    }

    if (centro) {
      request_body['nmCentro'] = centro
    }

    if (fornecedor) {
      request_body['nmFornecedor'] = fornecedor
    }

    if (unidadeGestoraID) {
      request_body['unidadeGestoraId'] = unidadeGestoraID
    }
  }

  const handleViewReport = () => {
    const request_body: IRequestBody = {
      ...(centrosIds.length > 0 && { centrosIds }),
      ...(contratosIds.length > 0 && { contratosIds }),
      ...(fornecedoresIds.length > 0 && { fornecedoresIds }),
      ...(empresasIds.length > 0 && { empresasIds }),
      ...(subcontratadasIds.length > 0 && { subcontratadasIds }),
      competenciaDataFim: moment(validaDataFim())?.toDate() || '---',
      competenciaDataIni: moment(periodoValidadeIni)?.toDate() || '---',
      flTodos: filterTodos || false,
      flValidacaoAnalista: filterVAnalista || false,
      flValidacaoContraparte: filterVContraparte || false,
      flStatusMovimentacao: filterStatusMovimentacao || false
    }

    setRequestBodyValues(request_body)
    setPersistInStorage()

    if (relatorio === 'HHT') {
      push({
        pathname: '/ngt/relatorios-vizualizar-efetivos-hht-salario',
        state: {
          name: `${tipo}${relatorio}`,
          request_body
        }
      })
    }

    if (relatorio === 'TTL' && tipo === 'Fornecedor') {
      push({
        pathname: '/ngt/relatorios-fornecedor',
        state: {
          name: `${tipo}${relatorio}`,
          request_body
        }
      })
    }
    if (relatorio === 'TTL' && tipo === 'Contrato') {
      push({
        pathname: '/ngt/relatorios-vizualizar-efetivos-terceiros-fornecedor',
        state: {
          name: `${tipo}${relatorio}`,
          request_body
        }
      })
    }
  }

  const unidadeGestoraRef = useRef(null)

  const contratosSizeMap = useRef({})
  const contratosListRef = useRef(null)
  const contratosSetSize = buildSetSize(contratosSizeMap, contratosListRef)

  const fornecedorSizeMap = useRef({})
  const fornecedorListRef = useRef(null)
  const fornecedorSetSize = buildSetSize(fornecedorSizeMap, fornecedorListRef)

  const empresaSizeMap = useRef({})
  const empresaListRef = useRef(null)
  const empresaSetSize = buildSetSize(empresaSizeMap, empresaListRef)

  const centroSizeMap = useRef({})
  const centroListRef = useRef(null)
  const centroSetSize = buildSetSize(centroSizeMap, centroListRef)

  const subFornecedoresSizeMap = useRef({})
  const subFornecedoresListRef = useRef(null)
  const subFornecedoresSetSize = buildSetSize(
    subFornecedoresSizeMap,
    subFornecedoresListRef
  )

  const [windowWidth] = useWindowResize()

  useEffect(() => {
    if (relatorio === 'HHT') {
      setPeriodoValidadeIni(moment(periodoValidadeFim)?.toDate())
    }
  }, [periodoValidadeFim])

  const [errorMessage, setErrorMessage] = useState('');

  const handlePeriodoValidadeFimChange = (selectedDate) => {
    if (selectedDate === null || selectedDate === undefined) {
      setErrorMessage("");
      setPeriodoValidadeFim(null);
      return;
    }
    const dateFim = new Date(selectedDate);

    if (!isValid(dateFim)) {
      setErrorMessage('*Insira uma data final valida.');
      return;
    }

    if (periodoValidadeIni && isBefore(dateFim, new Date(periodoValidadeIni.toString()))) {
      setErrorMessage('*A data final deve ser posterior à data inicial.');
      return;
    }

    setPeriodoValidadeFim(selectedDate);
    setErrorMessage('');
  }

  const handlePeriodoValidadeIniChange = (selectedDate) => {
    if (selectedDate === null || selectedDate === undefined) {
      setPeriodoValidadeIni(selectedDate);
      setErrorMessage('');
      return;
    }
    const dateInicio = new Date(selectedDate);

    if (!isValid(dateInicio)) {
      setErrorMessage('*Insira uma data inicial valida.');
      return;
    }

    if (periodoValidadeFim && !isBefore(dateInicio, new Date(periodoValidadeFim.toString()))) {
      setErrorMessage('*A data final deve ser posterior à data inicial.');
      return;
    }

    if (isBefore(new Date(), dateInicio)) {
      setErrorMessage('*A data inicial não pode ser posterior à data atual.');
      return;
    }

    setPeriodoValidadeIni(selectedDate);
    setErrorMessage('');
  }
  const handleDateChange = (date) => {
    if (moment(date, 'MM/yyyy').isValid()) {
      setPeriodoValidadeFim(moment(date, 'MM/yyyy').toDate());
    }
  }

  return (
    <Card
      marginTop={SPACING.spacing20}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Row alignItems="flex-start" justifyContent="space-between">
        <Row>
          <RadioGroup
            label="Relatório"
            onChange={(e) => setRelatorio(e.target.value)}
            row
            value={relatorio}
            listOptions={[
              { label: 'Efetivo de Terceiros', value: 'TTL' },
              { label: 'HHT x Salário', value: 'HHT' }
            ]}
          />
        </Row>
        {relatorio === 'HHT' ? (

          <Picker
            inputFormat="MM/yyyy"
            removeButton
            /* defaultValue={periodoValidadeFim?.toString() || ''} */
            views={['month', 'year']}
            label="Competência"
            type="monthAndYear"
            value={periodoValidadeFim}
            onChange={handleDateChange} //setPeriodoValidadeFim
            disabled={load ? true : false}
          />
        ) : (
          <><Col>
            <Row alignItems="flex-start">
              <Picker
                maxDate={new Date()}
                /* defaultValue={periodoValidadeIni?.toString() || ''} */
                views={['month', 'year']}
                //onChange={setPeriodoValidadeIni}
                onChange={handlePeriodoValidadeIniChange}
                label="Competência"
                type="monthAndYear"
                value={periodoValidadeIni} />
              <Text
                marginleft={SPACING.spacing10}
                marginright={SPACING.spacing10}
                margintop={SPACING.spacing30}
              >
                à
              </Text>
              <Picker
                maxDate={new Date()}
                views={['month', 'year']}
                label=""
                onChange={handlePeriodoValidadeFimChange}
                value={periodoValidadeFim}
                type="monthAndYear" />
              <Text
                marginleft={SPACING.spacing10}
                marginright={SPACING.spacing10}
                margintop={SPACING.spacing30}
              >
              </Text>
            </Row>
            {errorMessage && <Row style={{ color: 'red' }}>{errorMessage}</Row>}
          </Col>
          </>
        )}
      </Row>
      <Row>
        <RadioGroup
          label="Tipo"
          row
          value={tipo}
          onChange={(e) => setTipo(e.target.value)}
          listOptions={[
            { label: 'Contrato', value: 'Contrato' },
            { label: 'Fornecedor', value: 'Fornecedor' }
          ]}
        />
      </Row>
      <Grid
        gridCols="1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        alignItems="flex-start"
      >
        <Col>
          <Input
            width="300px"
            label="Contrato"
            placeholder="Nº"
            value={contrato}
            onChange={(e) => setContrato(e.target.value)}
            inputIcon={
              <MagnifyingGlassIcon onClick={() => getFillCards(true)} />
            }
          />
          <Span
            marginTop={SPACING.spacing20}
            text="Subcontratadas do Contrato"
            fontSize="1rem"
          />
          <CheckBox
            marginTop={SPACING.spacing20}
            checked={checkAllSub}
            disabled={contratoList.length === 0}
            onChange={(e) => handleCheckAll(e, 'contrato')}
            label="Marcar Todos"
          />
          <SimpleCard padding="0" minHeight="300px" maxHeight="300px">
            <List
              itemCount={contratoList.length}
              estimatedItemSize={30}
              itemSize={(index: number) => getItemSize(contratosSizeMap, index)}
              ref={contratosListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={contratoList[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={contratosSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'contrato',
                            contratoList[index].id
                          )
                        }
                        checked={contratoList[index].checked || false}
                        key={contratoList[index].id}
                        label={contratoList[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </SimpleCard>
        </Col>
        <Col>
          <Input
            label="Fornecedor"
            placeholder="Nome do Fornecedor"
            value={fornecedor}
            onChange={(e) => setFornecedor(e.target.value)}
            inputIcon={
              <MagnifyingGlassIcon onClick={() => getFillCards(true)} />
            }
          />
          <Span marginTop={SPACING.spacing20} text="." fontSize="1rem" />
          <CheckBox
            checked={checkAllFornecedor}
            marginTop={SPACING.spacing20}
            label="Marcar Todos"
            disabled={fornecedorList.length === 0}
            onChange={(e) => handleCheckAll(e, 'fornecedor')}
          />
          <SimpleCard padding="0" minHeight="300px" maxHeight="300px">
            <List
              itemCount={fornecedorList.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(fornecedorSizeMap, index)
              }
              ref={fornecedorListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={fornecedorList[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={fornecedorSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'fornecedor',
                            fornecedorList[index].id
                          )
                        }
                        checked={fornecedorList[index].checked || false}
                        key={fornecedorList[index].id}
                        label={fornecedorList[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </SimpleCard>
        </Col>
      </Grid>
      <Grid
        gridCols="0.8fr 0.8fr 1.5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        alignItems="flex-start"
      >
        <Col>
          <Input
            label="Empresa"
            placeholder="Nome da Empresa"
            value={empresa}
            onChange={(e) => setEmpresa(e.target.value)}
            inputIcon={
              <MagnifyingGlassIcon onClick={() => getFillCards(true)} />
            }
          />
          <CheckBox
            checked={checkAllEmpresa}
            marginTop={SPACING.spacing20}
            label="Marcar Todos"
            disabled={empresaList.length === 0}
            onChange={(e) => handleCheckAll(e, 'empresa')}
          />
          <SimpleCard padding="0" minHeight="300px" maxHeight="300px">
            <List
              itemCount={empresaList.length}
              estimatedItemSize={30}
              itemSize={(index: number) => getItemSize(empresaSizeMap, index)}
              ref={empresaListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={empresaList[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={empresaSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'empresa',
                            empresaList[index].id
                          )
                        }
                        checked={empresaList[index].checked || false}
                        key={empresaList[index].id}
                        label={empresaList[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </SimpleCard>
        </Col>
        <Col>
          <Input
            label="Centro"
            placeholder="Nome do Centro"
            value={centro}
            onChange={(e) => setCentro(e.target.value)}
            inputIcon={
              <MagnifyingGlassIcon onClick={() => getFillCards(true)} />
            }
          />
          <CheckBox
            checked={checkAllCentro}
            marginTop={SPACING.spacing20}
            label="Marcar Todos"
            disabled={centroList.length === 0}
            onChange={(e) => handleCheckAll(e, 'centro')}
          />
          <SimpleCard padding="0" minHeight="300px" maxHeight="300px">
            <List
              itemCount={centroList.length}
              estimatedItemSize={30}
              itemSize={(index: number) => getItemSize(centroSizeMap, index)}
              ref={centroListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={centroList[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={centroSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'centro',
                            centroList[index].id
                          )
                        }
                        checked={centroList[index].checked || false}
                        key={centroList[index].id}
                        label={centroList[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </SimpleCard>
        </Col>
        <Col marginTop={SPACING.spacing15}>
          <Input
            label="Subcontratadas dos Fornecedores"
            placeholder="Nome do Subcontratada"
            value={subcontratada}
            onChange={(e) => setSubcontratada(e.target.value)}
            inputIcon={
              <MagnifyingGlassIcon onClick={() => getFillCards(true)} />
            }
          />
          <CheckBox
            checked={checkAllSubFornecedor}
            marginTop={SPACING.spacing20}
            label="Marcar Todos"
            disabled={subFornecedoresList.length === 0}
            onChange={(e) => handleCheckAll(e, 'subcontratadas')}
          />
          <SimpleCard padding="0" minHeight="300px" maxHeight="300px">
            <List
              itemCount={subFornecedoresList.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(subFornecedoresSizeMap, index)
              }
              ref={subFornecedoresListRef}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <>
                  <div style={style} key={subFornecedoresList[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={subFornecedoresSetSize}
                    >
                      <CheckBox
                        onChange={(e) =>
                          handleChangeItem(
                            e.target.checked,
                            'subcontratadas',
                            subFornecedoresList[index].id
                          )
                        }
                        checked={subFornecedoresList[index].checked || false}
                        key={subFornecedoresList[index].id}
                        label={subFornecedoresList[index].name}
                      />
                    </ReportsRow>
                  </div>
                </>
              )}
            </List>
          </SimpleCard>
        </Col>
      </Grid>
      <Grid
        gridCols="3.4fr 1fr 1fr 1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        alignItems="flex-end"
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Col>
          <UnidadeGestoraFields
            ref={unidadeGestoraRef}
            gridCols={{
              Diretoria: 6,
              DiretoriaExecutiva: 6,
              Gerencia: 6,
              GerenciaGeral: 6,
              spacing: 3
            }}
            // defaultValue={unidadeGestoraID}
            onChange={setUnidadeGestoraID}
          />
        </Col>
        <Col marginBottom="65px">
          <CheckBox
            checked={filterTodos}
            label="Todos"
            onClick={() => {
              !filterTodos && setFilterVAnalista(false)
              !filterTodos && setFilterVContraparte(false)
              setFilterTodos(!filterTodos)
              localStorage.setItem("fLTodos", !filterTodos + "");
            }}
          />
        </Col>
        <Col marginBottom="65px">
          <CheckBox
            checked={filterVContraparte}
            label="Validação contraparte"
            onClick={() => {
              !filterVContraparte && setFilterTodos(false)
              setFilterVContraparte(!filterVContraparte)
              localStorage.setItem("fLTodos", "false");
            }}
          />
        </Col>
        <Col marginBottom="65px">
          <CheckBox
            checked={filterVAnalista}
            label="Validação analista"
            onClick={() => {
              !filterVAnalista && setFilterTodos(false)
              setFilterVAnalista(!filterVAnalista)
              localStorage.setItem("fLTodos", "false");
            }}
          />
        </Col>
        <Col marginBottom='65px'>
          <CheckBox
            checked={filterStatusMovimentacao}
            label='Lançamentos incompletos'
            onClick={() => {
              !filterStatusMovimentacao && setFilterTodos(false)
              setFilterStatusMovimentacao(!filterStatusMovimentacao)
              localStorage.setItem("fLTodos", "false");
            }}
          />
        </Col>
      </Grid>
      <Row
        marginTop={SPACING.spacing20}
        alignItems="center"
        justifyContent="flex-end"
      >
        <Button
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
          onClick={handleClear}
          text="Limpar"
          variantButton="text"
        />
        <Button onClick={handleViewReport} text="VISUALIZAR" />
      </Row>
    </Card>
  )
}

export default ReportsEffectives
